module.exports = __webpack_public_path__ + "img/question.c6bb0108.png";